import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import styled from 'styled-components';
import Textarea from '../atoms/Textarea';
import InputLabel from '../atoms/labels/InputLabel';
import ErrorLabel from '../atoms/labels/ErrorLabel';
import _ from 'lodash';
const OuterWrapper = styled.div `
    margin-bottom: 20px;
    max-width: ${props => (props.fullWidth ? 'none' : 'none')};

    &:last-child {
        margin-bottom: 0;
    }
`;
const StyledTextareaItem = styled.div `
    position: relative;
    display: block;
`;
const FocusBorder = styled.span `
    position: absolute;
    bottom: 0;
    left: 0;
    transform-origin: 0;
    transform: scaleX(0);
    width: 100%;
    height: 1px;
    background-color: ${props => props.theme.secondary};
    transition: all 300ms ease-in-out;
    border-radius: 1px;
`;
const TextareaItem = ({ className, label, error, fullWidth, ...props }) => {
    const [fid] = useState(() => props.id || _.uniqueId('field-'));
    return (_jsxs(OuterWrapper, { fullWidth: fullWidth, children: [_jsxs(StyledTextareaItem, { className: className, children: [_jsx(InputLabel, { htmlFor: fid, required: props.required, children: label }), _jsx(Textarea, { ...props, id: fid }), _jsx(FocusBorder, { className: "focus-border" })] }), error && _jsx(ErrorLabel, { children: error })] }));
};
export default TextareaItem;
